import { Select } from "antd";
import { FC, useMemo } from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";
import { useAppSelector } from "../../../hooks/redux";
import { isHomeHealthExternalUser } from "../../../constants/sso";

export interface IFacilitySelector {
  clinicList: IClinic[];
  selectedClinic?: IClinic;
  onFacilityChange: (clinicId: number) => void;
}

export const FacilitySelector: FC<IFacilitySelector> = ({
  clinicList,
  selectedClinic,
  onFacilityChange,
}) => {
  const { user } = useAppSelector((state) => ({
    user: state.auth.user,
  }));

  // Check if user belongs to home_health_external group or logged in via Microsoft SSO
  const isHomeHealthExternal = useMemo(() => {
    return isHomeHealthExternalUser(user?.groups);
  }, [user?.groups]);

  return (
    <Select
      className={classNames(styles.selector, {
        [styles.externalHomeHealth]: isHomeHealthExternal,
      })}
      value={selectedClinic?.id}
      onChange={onFacilityChange}
      placeholder="Select facility"
      showSearch
      filterOption={(input, option) =>
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
      optionLabelProp="label"
      options={clinicList.map((clinic) => ({
        value: clinic.id,
        label: clinic.name,
        address: clinic.address,
      }))}
      optionRender={(option) => (
        <div className={styles.facilityOption}>
          <span className={styles.name}>{option.data.label}</span>
        </div>
      )}
      style={{ width: 308 }}
    />
  );
};
